// src/pages/ServerConfig.js

import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ServerSetup from '../components/serverSetup/ServerSetup';
import { AuthContext } from '../context/AuthContext';

const ServerConfig = () => {
  const {
    guilds,
    setGuilds,
    selectedGuild,
    setSelectedGuild,
    accessToken,
    guildId,
    setGuildId,
    fetchGuilds,
    user,
  } = useContext(AuthContext);

  const navigate = useNavigate();


  // Redirect to login if not authenticated
  useEffect(() => {
    console.log('ServerConfig: Mounted with guildId:', guildId);
    if (!accessToken) {
      console.log('ServerConfig: No accessToken, redirecting to /login');
      navigate('/login');
    }
  }, [accessToken, navigate]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 4,
        overflowY: 'auto',
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ textAlign: 'center' }}
      >
        Server Configuration
      </Typography>

      <ServerSetup />
    </Box>
  );
};

export default ServerConfig;


